import { isEscape, returnFocus } from "./app/utils.js";

var returnFocusTo = window.returnFocusTo || null;
const breakpoints = {
    xs: 0,
    md: 768,
    lg: 1025,
    xl: 1536
};

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        // close things then return focus
        returnFocus();
    }
});
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}

require('./app/primary-navigation');
require('./app/locations');
require('./app/materials-calculator');
require('./app/galleries.js');
